import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import {
  GET_UTILITY_REQUEST_ISSUE_TYPES,
  GET_UTILITY_REQUEST_ISSUE_TYPES_SUCCESS,
  GET_UTILITY_REQUEST_ISSUE_TYPES_ERROR,
} from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getUtilityRequestIssueTypes() {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/utility-request/issue-types`,
      method: 'GET',
      headers: filteredHeaders,
    });

    if (response.status === 200) {
      yield put({
        type: GET_UTILITY_REQUEST_ISSUE_TYPES_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_UTILITY_REQUEST_ISSUE_TYPES_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_UTILITY_REQUEST_ISSUE_TYPES_ERROR, payload: error });
  }
}

export function* watchGetUtilityRequestIssueTypes() {
  yield takeEvery(GET_UTILITY_REQUEST_ISSUE_TYPES, getUtilityRequestIssueTypes);
}

function* getUtilityRequestIssueTypesSaga() {
  yield all([fork(watchGetUtilityRequestIssueTypes)]);
}

export default getUtilityRequestIssueTypesSaga;
